import styles from './styles.module.scss';

const ScoringGrid = () => {
  const scoringGrid = Array.from({ length: 10 }, (_, i) => (i + 1) * 10);

  return (
    <div className={styles.scoringGrid}>
      {scoringGrid.map((column) => {
        return <div className={styles.scoringGridLine} key={column.toString()}></div>;
      })}
    </div>
  );
};

export default ScoringGrid;
